import template from './branch_funding_source_holiday.all.html';
import controller from './branch_funding_source_holiday.all.controller';
import './branch_funding_source_holiday.all.scss';

let branchFundingSourceHolidayAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template,
    controller
}

export default branchFundingSourceHolidayAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/all/branch_funding_source_holiday.all.component.js